import { createMarkup } from 'app/scripts/utils';

import Container from './Container';

export default function AnyQuery({ data }) {
  return (
    <Container>
      <div className="max-w-[1100px] mx-auto grid md:grid-cols-2 grid-cols-1 gap-8">
        {data?.map((items, key) => (
          <div
            key={key}
            className="bg-[#E8F1FF] border border-[#E0E1E1] rounded-[20px] p-10"
          >
            <h6 className="text-[24px] font-[700] text-black mb-4">
              {items?.title}
            </h6>
            {items?.descriptionEditor && (
              <div
                className=" font-[400] text-[16px] text-[#010A1B] query_link"
                dangerouslySetInnerHTML={createMarkup(items?.descriptionEditor)}
              ></div>
            )}
          </div>
        ))}
      </div>
    </Container>
  );
}
